





































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Tjxx extends Vue {
    @Prop({ type: [Number, String] })
    year!: number;

    form = {
        accountBookId: this.$store.state.accountBook.id,
        gender: "",
        year: this.year,
        isBuildTeamOrganization: 1,
        teamChargeName: "",
        officePhone: "",
        mobilePhone: "",
        teamAffiliateUnit: "",
        teamBuildSituation: "",
        teamPreBuildSituation: "",
        teamPreBuildWay: "",
        teamBuildWay: "",
        teamNumber: "",
        youthUnderNumber: "",
        teamBuildTime: "",

    }
    mounted() {
        this.fetchData();
    }
    async save() {
        const keys = Object.keys(this.form);
        if(this.form.teamBuildSituation ==="" && this.form.teamPreBuildSituation ==="") {
            this.$notify({
                title: "温馨提示",
                message: "请将所有信息填写完整",
                type: "warning"
            });
        }
        if(this.form.teamPreBuildWay ==="" && this.form.teamBuildWay ==="") {
            this.$notify({
                title: "温馨提示",
                message: "请将所有信息填写完整",
                type: "warning"
            });
        }
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if(this.form.isBuildTeamOrganization === 1) {
                // @ts-ignore
                // if (key != "teamPreBuildWay" && key != "teamBuildWay" && key != "teamBuildSituation" && key != "teamPreBuildSituation") {
                    // @ts-ignore
                    if ((this.form[key] === null || this.form[key] === "") && key !== "id" && key !== "gmtCreate" && key !== "gmtModified") {
                        console.log(key)
                        this.$notify({
                            title: "温馨提示",
                            message: "请将所有信息填写完整",
                            type: "warning"
                        });
                        return;
                    }
                // }
            } else {
                // @ts-ignore
                if (key  === "isBuildTeamOrganization" || key  === "teamBuildSituation" || key  === "teamBuildWay" || key  === "teamNumber"  || key  === "youthUnderNumber") {
                    // @ts-ignore
                    if (this.form[key] === null || this.form[key] === "" && key !=="id") {
                        this.$notify({
                            title: "温馨提示",
                            message: "请将所有信息填写完整",
                            type: "warning"
                        });
                        return;
                    }
                }
            }

        }
        await Vue.axios.post(`gsnb/tjxx/save`, this.form);
        this.fetchData()
        this.$emit("update", this.form);
    }
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/tjxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        console.log(res)
        if (res.data.data) {
            this.form = res.data.data
            // this.form.teamBuildTime = this.$utils.simpleDateFormat(new Date(this.form.teamBuildTime),"d",true)
        }
    }

}
